import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import AuthMessage from './components/Common/Message';
import { SystemErrorProvider } from './components/Error/SystemErrorContext';
import SystemErrorModal from './components/Error/SystemErrorModal';
import PrivateRoute from './components/PrivateRoute/PrivateRoute'
import EmailUpdateVerificationPage from './pages/Auth/EmailUpdateVerificationPage';
import Login from './pages/Auth/Login';
import RequestReset from './pages/Auth/PasswordRequestReset';
import PasswordReset from './pages/Auth/PasswordReset';
import Register from './pages/Auth/Register';
import MainLayout from './pages/MainLayout';
import ExecutionLogPage from './components/AIMode/ChatWindow/ExecutionLogWindow';

const App: React.FC = () => {
  return (
    <SystemErrorProvider>
      <Router>
        <div style={{ height: '100dvh', overflow: 'hidden' }}>
          <Routes>
            <Route path="/" element={<Navigate replace to="/auth/login" />} />
            <Route path="/auth/login" element={<Login />} />
            <Route path="/auth/password/request-reset" element={<RequestReset />} />
            <Route path="/auth/password/reset" element={<PasswordReset />} />
            <Route path="/auth/register" element={<Register />} />
            <Route path="/auth/message/:type" element={<AuthMessage />} />
            <Route path="/auth/email/update" element={<EmailUpdateVerificationPage />} />
            <Route path="/execution-log/:assistantMessageId" element={<ExecutionLogPage />} />

            {/* MainLayout wraps the content */}
            <Route path="/main/*" element={<PrivateRoute element={MainLayout} />} />
          </Routes>

          {/* The Critical Error Modal must be inside the Router */}
          <SystemErrorModal />
        </div>
      </Router>
    </SystemErrorProvider>
  );
};

export default App;
